import { render, staticRenderFns } from "./UnderfloorHeating.vue?vue&type=template&id=08574b2e&"
import script from "./UnderfloorHeating.vue?vue&type=script&lang=js&"
export * from "./UnderfloorHeating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports